module.exports = __webpack_public_path__ + "static/media/event.dd8f2f78.svg";